// extracted by mini-css-extract-plugin
module.exports = {"link":"bs-lp20-src-components-link-module-link","externalLinkIcon":"bs-lp20-src-components-link-module-external-link-icon"};